export default __webpack_public_path__ + "static/media/analysisofalgorithms.52264298.png";